import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    participants: [
      {
        id: 1,
        function: 'athlete',
        team: 'Alpha Team',
        first_name: 'Reinhold',
        last_name: 'Burghardt',
        birthday: '1995-11-19',
        checkedIn: false,
        equipmentDeposit: null,
        gloves: '',
        shinguards: '',
        competition_fit: null,
        medicalEvaluationGeneralData: {
          lastMatch: '2020-02-18',
          lastMatchEvent: 'NDW',
          medications: 'None',
          allergies: 'None',
          medicalHistory: 'None',
        },
        medicalEvaluationPre: {},
        medicalEvaluationPost: {},
        weight: '77.1',
        weight_class: {
          name: 'lightweight',
          weight_max: 70.3,
          weight_min: 65.9,
        },
      },
      {
        id: 2,
        function: 'athlete',
        team: 'Alpha Team',
        first_name: 'Patricia',
        last_name: 'Achenbach',
        birthday: '2020-01-01',
        checkedIn: true,
        equipmentDeposit: null,
        gloves: '',
        shinguards: '',
        competition_fit: true,
        medicalEvaluationGeneralData: {
          lastMatch: '',
          lastMatchEvent: '',
          medications: '',
          allergies: '',
          medicalHistory: '',
        },
        medicalEvaluationPre: {},
        medicalEvaluationPost: {},
        weight: '76.0',
        weight_class: {
          name: 'welterweight',
          weight_max: 77.1,
          weight_min: 70.4,
        },
      },
      {
        id: 3,
        function: 'athlete',
        team: 'Alpha Team',
        first_name: 'Marius',
        last_name: 'Honold',
        birthday: '2020-01-01',
        checkedIn: false,
        equipmentDeposit: null,
        gloves: '',
        shinguards: '',
        competition_fit: true,
        medicalEvaluationGeneralData: {
          lastMatch: '2020-01-01',
          lastMatchEvent: '',
          medications: '',
          allergies: '',
          medicalHistory: '',
        },
        medicalEvaluationPre: {},
        medicalEvaluationPost: {},
        weight: '',
        weight_class: {
          name: 'middleweight',
          weight_max: 83.9,
          weight_min: 77.2,
        },
      },
      {
        id: 4,
        function: 'athlete',
        team: 'Beta Team',
        first_name: 'Christel',
        last_name: 'Reinicke',
        birthday: '2020-01-01',
        checkedIn: false,
        equipmentDeposit: null,
        gloves: '',
        shinguards: '',
        competition_fit: false,
        medicalEvaluationGeneralData: {
          lastMatch: '2020-01-02',
          lastMatchEvent: '',
          medications: '',
          allergies: '',
          medicalHistory: '',
        },
        medicalEvaluationPre: {},
        medicalEvaluationPost: {},
        weight: '',
        weight_class: {
          name: 'light-heavyweight',
          weight_max: 93.0,
          weight_min: 84.0,
        },
      },
      {
        id: 5,
        function: 'athlete',
        team: 'Beta Team',
        first_name: 'Antonio',
        last_name: 'Hubauer',
        birthday: '2020-01-01',
        checkedIn: false,
        equipmentDeposit: null,
        gloves: '',
        shinguards: '',
        competition_fit: null,
        medicalEvaluationGeneralData: {
          lastMatch: '2020-01-03',
          lastMatchEvent: '',
          medications: '',
          allergies: '',
          medicalHistory: '',
        },
        medicalEvaluationPre: {},
        medicalEvaluationPost: {},
        weight: '',
        weight_class: {
          name: 'lightweight',
          weight_max: 70.3,
          weight_min: 65.9,
        },
      },
      {
        id: 6,
        function: 'official',
        team: 'GEMMAF',
        first_name: 'Franz',
        last_name: 'Schwerdtmann',
        checkedIn: false,
      },
      {
        id: 7,
        function: 'official',
        team: 'GEMMAF',
        first_name: 'Clemens',
        last_name: 'Werner',
        checkedIn: false,
      },
      {
        id: 8,
        function: 'official',
        team: 'GEMMAF',
        first_name: 'Leon',
        last_name: 'Mark',
        checkedIn: false,
      },
      {
        id: 9,
        function: 'trainer',
        team: 'Alpha Team',
        first_name: 'Peter',
        last_name: 'Lustig',
        checkedIn: false,
      },
      {
        id: 10,
        function: 'trainer',
        team: 'Beta Team',
        first_name: 'Hans',
        last_name: 'Jürgen',
        checkedIn: false,
      },
    ],
    setup: {
      currentWeightClass: null,
      classes: [
        {
          athletes: [
            { id: 1, name: 'Alessandro Turner', team: 'Extreme MMA' },
            { id: 2, name: 'Conall Rice', team: 'Smash Bros' },
            { id: 3, name: 'Harris Young', team: 'A-Team' },
            { id: 4, name: 'Lenny Ashton', team: 'hanuta MMA' },
          ],
          fights: [],
          gender: 'female',
          id: 1,
          weight: 155,
        },
        {
          athletes: [
            { id: 5, name: 'Jax Compton', team: 'Extreme MMA' },
            { id: 6, name: 'Reuben Caldwell', team: 'Smash Bros' },
            { id: 7, name: 'Imaan Hanson', team: 'A-Team' },
            { id: 8, name: 'Jordi Valenzuela', team: 'hanuta MMA' },
            { id: 9, name: 'Woody Burnett', team: 'Top MMA' },
            { id: 10, name: 'Inigo Matthams', team: 'Pro Hoes' },
            { id: 11, name: 'August Santos', team: 'Team duplo' },
            { id: 12, name: 'Korey Murray', team: 'hanuta MMA' },
          ],
          fights: [],
          gender: 'male',
          id: 2,
          title: 'Welterweight',
          weight: 170,
        },
      ],
      matchFights: {
        athletes: [
          {
            id: 3,
            name: 'Harris Young',
            team: 'A-Team',
            weight: 82.5,
            weightClass: 185,
          },
          {
            id: 4,
            name: 'Lenny Ashton',
            team: 'hanuta MMA',
            weight: 81.9,
            weightClass: 185,
          },
        ],
        fights: [
          {
            id: 1,
            type: 'pro',
            schedule: null,
            rounds: 3,
            duration: 180,
            extraTime: 300,
            athleteRed: {
              id: 1,
              name: 'Alessandro Turner',
              team: 'Extreme MMA',
              weight: 69.9,
              weightClass: 155,
            },
            athleteBlue: {
              id: 2,
              name: 'Conall Rice',
              team: 'Smash Bros',
              weight: 68.8,
              weightClass: 155,
            },
            weightClass: 155,
          },
        ],
      },
      settings: [
        {
          id: 'qf', label: 'Quarter-Finals', rounds: 2, duration: 120, additionalTime: 120,
        },
        {
          id: 'sf', label: 'Semi-Finals', rounds: 2, duration: 120, additionalTime: 120,
        },
        {
          id: 'f', label: 'Finals', rounds: 3, duration: 180, additionalTime: 120,
        },
      ],
      schedule: [],
    },
  },
  mutations: {
    assignAthleteToFight(state, payload) {
      const clazz = state.setup.classes.find((c) => c.id === payload.classId);
      const fight = clazz.fights.find((f) => f.id === payload.fightId);
      if (payload.corner === 'red') fight.athleteRed = payload.athlete;
      if (payload.corner === 'blue') fight.athleteBlue = payload.athlete;
      clazz.athletes = clazz.athletes.filter((athlete) => athlete.id !== payload.athlete.id);
    },
    createFightMockup(state, fight) {
      const clazz = state.setup.classes.find((c) => c.id === fight.classId);
      clazz.fights.push(fight);
    },
    createMatchFight(state, fight) {
      const newId = Math.max(state.setup.matchFights.fights.map((f) => f.id)) + 1;
      const newFight = fight;
      newFight.id = newId;
      state.setup.matchFights.fights.push(newFight);
    },
    discardSetupMatchFight(state, fight) {
      state.setup.matchFights.fights = state.setup.matchFights.fights
        .filter((f) => f.id !== fight.id);
    },
    pushUnassignedAthlete(state, payload) {
      const clazz = state.setup.classes.find((c) => c.id === payload.classId);
      clazz.athletes.push(payload.athlete);
    },
    removeAthleteFromSetupMatchFight(state, athlete) {
      state.setup.matchFights.athletes = state.setup.matchFights.athletes.concat(athlete);
    },
    removeMatchFightAthleteFromUnassigned(state, id) {
      const [...athletes] = state.setup.matchFights.athletes;
      state.setup.matchFights.athletes = athletes.filter((athlete) => athlete.id !== id);
    },
    removeAthleteFromFight(state, payload) {
      const fight = state.setup.classes.map((clazz) => clazz.fights)
        .reduce((a, b) => a.concat(b), [])
        .find((f) => f.id === payload.fightId);
      if (payload.corner === 'red') fight.athleteRed = 'unassigned';
      if (payload.corner === 'blue') fight.athleteBlue = 'unassigned';
    },
    saveSetupMatchFight(state, fight) {
      Object.assign(state.setup.matchFights.fights
        .find((f) => f.id === fight.id), fight);
    },
    setAthleteForFight(state, payload) {
      const clazz = state.setup.classes.find((c) => c.id === payload.classId);
      const selectedFight = clazz.fights.find((fight) => fight.classId === payload.classId
        && fight.nr === payload.nr);
      if (payload.corner === 'red') selectedFight.athleteRed = payload.athlete;
      if (payload.corner === 'blue') selectedFight.athleteBlue = payload.athlete;
      clazz.athletes = clazz.athletes.filter(
        (item) => item !== payload.athlete,
      );
    },
    setCurrentWeightClass(state, id) {
      state.setup.currentWeightClass = id;
    },
    setScheduleFights(state, fights) {
      state.setup.schedule = fights;
    },
    setTournamentSettings(state, payload) {
      const setting = state.setup.settings.find((item) => item.id === payload.id);
      setting[payload.item] = payload.value;
    },
    setValue(state, payload) {
      const participant = state.participants.find((p) => p.id === payload.id);
      participant[payload.key] = payload.value;
    },
  },
  actions: {},
  getters: {
    getFightMockups: (state) => state.setup.classes
      .find((c) => c.id === state.setup.currentWeightClass).fights,
    getSetupMatchFights: (state) => state.setup.matchFights.fights,
    getSetupMatchFight: (state) => (id) => state.setup.matchFights.fights
      .find((fight) => fight.id === id),
    getParticipant: (state) => (id) => state.participants.find((p) => p.id === id),
    getAthletes: (state) => state.participants.filter((p) => p.function === 'athlete'),
    hasCorrectWeight: (state, getters) => (id) => {
      const athlete = getters.getParticipant(id);
      const TOLERANCE = 0.5;
      if (athlete.weight === '') return null;
      if (athlete.weight_class.name === 'catchweight'
        && athlete.weight <= athlete.weight_class.weight_max) return true;
      if (athlete.weight <= athlete.weight_class.weight_max + TOLERANCE) return true;
      return false;
    },
  },
  modules: {},
});
